import React, { useEffect, useState } from "react";
import SidebarPopup from "../../Components/SidebarPopup/SidebarPopup";
import { DropDownBox } from "../../Components/SidebarPopup/style";
import search from '../../assets/images/search.svg'
import animationData1 from "../../assets/lotties/question.json";
import ModalData from "../../Components/ModalData/ModalData";
import { cleanName, isEmpty, isNumber } from "../../utils/common";
import { AlertWrapper } from "../../Components/Modal/style";

import {
  approverTenant,
  getTelent,
  policeVerificationDocUpload,
  tenantStatusUpdate,
} from "../../utils/api";
import { ModalPopUp } from "../../Components/ModalPopUp/ModalPopUp";
import FileUploadBox from "../../Components/UploadFile/FileUploadBox";
import styled from "styled-components";
import Input from "../../Components/Input/Input";
import Verified from "../../Components/UI/Verified";
import { useNavigate } from "react-router-dom";

function TenantKycDetails({ close = () => {}, userName = "" }) {
  const [loader, setLoader] = useState(false);
  const [loaderApprove, setLoaderApprove] = useState(false);
  const [msg, setMsg] = useState({});

  const [user, setUser] = useState({});
  const [openDoc, setOpenDoc] = useState({});
  const [file, setFile] = useState(null);
  const [file1, setFile1] = useState(null);
  const [mobile, setMobile] = useState(userName || "");
  const [message, setMessage] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const [confirmCheck, setConfirmCheck] = useState(false);
  const [showUpload, setUpload] = useState(true);

  const defaultOptions1 = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
  };



  const handleApiData = async (userName) => {
    if (userName.length < 10) {
      return;
    }
    setLoader(true);
    getTelent(userName).then((resp) => {
      setLoader(false);
      setConfirmCheck(false);
      setFile(null);
      setUpload(true);

      if (resp?.data?.data) {
        setUser(resp?.data?.data?.[0] || {});

      }
    });
  };

  const handleMobileChange = (value) => {
    if (!isNumber(value) && !isEmpty(value)) return;
    setMobile(value);
  };

  useEffect(() => {
    if (!isEmpty(userName)) {
      handleApiData(mobile);
    }
  }, [userName]);

  const approveTenant = () => {
    setLoaderApprove(true);
    setConfirm(null);
    tenantStatusUpdate(user?.uuid, "ACTIVE")
      .then((res) => {
        if (res?.data?.message === "SUCCESS") {
          setMessage({ type: "success", msg: `Tenant approved successfully` });
          handleApiData(mobile);
        } else {
          const errorMsg = res?.data?.errorCodeList?.length
            ? res?.data?.errorCodeList.join(", ")
            : res?.data?.msg;
          setMessage({
            type: "error",
            msg: errorMsg || "Error approving Tenant",
          });
        }
      })
      .catch((err) => {
        setMessage({
          type: "error",
          msg: `Error approving Tenant: ${
            err?.response?.data?.message || err.message
          }`,
        });
      })
      .finally(() => {
        setLoaderApprove(false);
      });
  };

  const uploadFile = (type="") => {
    setLoaderApprove(true);
    setConfirm(null);
    const formData = new FormData();
    if(type === "rent"){
formData.append("docFile", file1);
    }else{
formData.append("docFile", file);
    }
    
 

    const docType =  type === "rent"?"RENT_AGREEMENT":"POLICE_VARIFICATION_FORM"
   

    policeVerificationDocUpload(formData,user?.uuid,docType)
      .then((res) => {
        if (res?.data?.message === "SUCCESS") {
          setFile(null);
          setMessage({
            type: "success",
            msg: `${type === "rent"?"Rent Aggrement":"Police Verification"} document upload successfully`,
          });
          handleApiData(mobile);
        } else {
          const errorMsg = res?.data?.errorCodeList?.length
            ? res?.data?.errorCodeList.join(", ")
            : res?.data?.msg;
          setMessage({
            type: "error",
            msg: errorMsg ||` ${type === "rent"? "Rent Aggrement":"Police Verification"} document upload failed`,
          });
        }
      })
      .catch((err) => {
        setMessage({
          type: "error",
          msg: `Error document upload: ${
            err?.response?.data?.message || err.message
          }`,
        });
      })
      .finally(() => {
        setLoaderApprove(false);
      });
  };

  useEffect(() => {
    if (isEmpty(message)) return;
    const timerId = setTimeout(() => {
      setMessage(null);
    }, 5000);
    return () => {
      clearTimeout(timerId);
    };
  }, [message]);

   const navigate = useNavigate();

  const handleClick = (href) => {
    navigate(href, {
      state: user,
    })
  }

  return (
    <div>
      {!isEmpty(message) && (
        <AlertWrapper className={`${message.type} globle`}>
          <span className="close" onClick={() => setMessage(null)}>
            ×
          </span>
          {message.msg}
        </AlertWrapper>
      )}
      {!isEmpty(confirm) && (
        <ModalData
          onClickCancel={() => setConfirm(null)}
          onClickConfirm={() => approveTenant()}
          lottieOptions={defaultOptions1}
          heading1={confirm}
        />
      )}

      <SidebarPopup
        close={close}
        title="Tenant details"
        randerInput={
          <>
          <div style={{display:"flex", flexDirection:"row" , alignItems:"center"}}>
          <p style={{paddingRight:"5px"}}>Mobile No:</p>
          <div className="mobileSearchContainer">
            <Input
              type="text"
              maxLength={10}
              placeholder="Enter your mobile number"
              name={"mobile"}
              value={mobile}
              onChange={(e) => handleMobileChange(e.target.value)}
              className={`searchUser`}
              click={() => (loader ? "" : handleApiData(mobile))}
              isError={mobile && mobile.length < 10}
            />
             <div className="searchButtonWrapper">
              
    <button
      type="button"
      onClick={() => {
        if (!loader && mobile.length === 10) {
          handleApiData(mobile);
        }
      }}
      className="searchButton"
      disabled={loader || mobile.length < 10}
    >
  
      
        <img src={search} style={{height:"30px" , width:"20px"}} alt="search" />
     
    </button>
  </div>
  </div>
            
          </div>
          </>
        }
        bodyStyle={{ paddingBottom: "100px" }}
        randerFooter={
          isEmpty(
            user?.tenantFullName && user?.mobileNumber
          ) ? null : user.status === "ACTIVE" ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <label for="acceptTerms">
                  This tenant is verified based on submitted documentation
                </label>
                <Verified />
              </div>
            </>
          ) : (
            <>
              <div className="SidebarFooter flex justify-between gap-10">
                <div style={{ display: "flex", gap: "10px" }}>
                  <input
                    type="checkbox"
                    id="acceptTerms"
                    checked={confirmCheck}
                    onChange={(e) => setConfirmCheck(e.target.checked)}
                    style={{ alignSelf: "flex-start", height: "20px" }}
                  />
                  <label for="acceptTerms">
                    You understand that giving false or incorrect confirmation
                    could have legal consequences, and you take full
                    responsibility for checking the documents.
                  </label>
                </div>

                <div className="buttons">
                  {" "}
                  <button
                    disabled={loaderApprove || !confirmCheck}
                    style={{ whiteSpace: "nowrap" }}
                    onClick={() =>
                      setConfirm(
                        "Are you sure you want to approve this tenant?"
                      )
                    }
                  >
                    Approve Tenant
                  </button>
                </div>
              </div>
            </>
          )
        }
      >
        {loader ? (
          <>
            <DropDownBox style={{ height: "164px" }}></DropDownBox>
            <DropDownBox style={{ height: "144px" }}></DropDownBox>
            <DropDownBox style={{ height: "122px" }}></DropDownBox>
          </>
        ) : (
          <>
            {!isEmpty(msg) && (
              <AlertWrapper className={`${msg?.type} local`}>
                <span className="close" onClick={() => setMsg({})}>
                  ×
                </span>
                {msg.msg}
              </AlertWrapper>
            )}
            <DropDownBox>
              <h2>Tenant details</h2>
              {isEmpty(user?.tenantFullName && user?.mobileNumber) ? (
                <>
                  <p
                    style={{
                      padding: "8px 12px",
                      textAlign: "center",
                      fontSize: "12px",
                      color: "red",
                    }}
                  >
                    No Data found
                  </p>
                </>
              ) : (
                <>
                  <div>
                    <div className="kycolumn">
                      <h4 className="title">Name</h4>
                      <span className="value">
                        {user?.tenantFullName || "NA"}
                      </span>
                    </div>
                    <div className="kycolumn">
                      <h4 className="title">Mobile No.</h4>
                      <span className="value">
                        {user?.mobileNumber || "NA"}
                      </span>
                    </div>
                    <div className="kycolumn">
                      <h4 className="title">Email</h4>
                      <span className="value">{user?.emailId || "NA"}</span>
                    </div>
                    <div className="kycolumn">
                      <h4 className="title">DOB</h4>
                      <div className={`status`}>{user?.dob || "NA"}</div>
                    </div>
                    
                  </div>
               
                    <div className="kycolumn">
                      <h4 className="title">Gender</h4>
                      <span className="value">
                        {user?.gender
                          ? user?.gender === "M"
                            ? "Male"
                            : "Female"
                          : "NA"}
                      </span>
                    </div>
                    <div className="kycolumn">
                      <h4 className="title">Care Of</h4>
                      <span className="value">{cleanName(user?.careOf || "")}</span>
                    </div>
                    <div className="kycolumn" style={{ flex: "0 0 50%" }}>
                      <h4 className="title  spacing">Permanent Address</h4>
                      <span className="value">
                        {user?.permanentAddress || "NA"}
                      </span>
                    </div>
                    <div className="kycolumn">
                      <h4 className="title">Occupation</h4>
                      <span className="value">{user?.occupation || "NA"}</span>
                    </div>
                    <div className="kycolumn">
                      <h4 className="title">Office Number</h4>
                      <span className="value">
                        {user?.officeNumber || "NA"}
                      </span>
                    </div>
                    <div className="kycolumn" style={{ flex: "0 0 50%" }}>
                      <h4 className="title">Office Address</h4>
                      <span className="value">
                        {user?.officeAddress || "NA"}
                      </span>
                    </div>
                    <div className="kycolumn">
                      <h4 className="title">Aadhaar Verified Name</h4>
                      <span className="value">
                        {user?.aadhaarVerifiedName || "NA"}
                      </span>
                    </div>

                                      <div className="flex justify-between gap10"style={{justifyContent:"end", marginTop:"10px"}}> <button onClick={()=>handleClick("/rent-aggrement-format")}  style={{fontSize:"14px",textDecoration:"underline",alignSelf:"flex-start"}}>Rent Aggrement Form</button> <button onClick={()=>handleClick("/police-verification-form")} style={{fontSize:"14px",textDecoration:"underline",alignSelf:"flex-start"}}>Police Verification form</button></div>
              
              
                </>
              )}
            </DropDownBox>

            {(!isEmpty(user?.accommodationDetail) || !isEmpty(user?.rentalRecord))  &&
                 <DropDownBox>
            {!isEmpty(user?.rentalRecord )   &&      <>
              <h2>Tenant Record</h2>
                
                  <div>
                    <div className="kycolumn">
                      <h4 className="title">Room Number</h4>
                      <span className="value">
                        {user?.rentalRecord?.roomNumber || "NA"}
                      </span>
                    </div>
                    <div className="kycolumn">
                      <h4 className="title">Rent Amount</h4>
                      <span className="value">
                        {user?.rentalRecord?.rentAmount || "NA"}
                      </span>
                    </div>
                    <div className="kycolumn" style={{marginTop:"20px"}}>
                      <h4 className="title">Due Date</h4>
                      <span className="value">
                        {user?.rentalRecord?.dueDate || "NA"}
                      </span>
                    </div>
                 
                    
                  </div>
                </>}
                   
                  { <>
                    <h2 >Accommodation Detail</h2>

                    <div>
                        <div className="kycolumn">
                      <h4 className="title">Owner Name</h4>
                      <span className="value">
                        {user?.accommodationDetail?.ownerName || "NA"}
                      </span>
                    </div>
                        <div className="kycolumn">
                      <h4 className="title">Owner Parent Name</h4>
                      <span className="value">
                        {user?.accommodationDetail?.ownerParentName || "NA"}
                      </span>
                    </div>
                        <div className="kycolumn">
                      <h4 className="title">Contact Number</h4>
                      <span className="value">
                        {user?.accommodationDetail?.contactNumber || "NA"}
                      </span>
                    </div>
                        <div className="kycolumn">
                      <h4 className="title">Address</h4>
                      <span className="value">
                        {`${user?.accommodationDetail?.addressLine}, ${user?.accommodationDetail?.city}, ${user?.accommodationDetail?.state}, ${user?.accommodationDetail?.postalCode}` || "NA"}
                      </span>
                    </div>
                      <div className="kycolumn">
                      <h4 className="title">Locality</h4>
                      <span className="value">
                        {user?.accommodationDetail?.locality || "NA"}
                      </span>
                    </div>
                      <div className="kycolumn">
                      <h4 className="title">Police Station</h4>
                      <span className="value">
                        {user?.accommodationDetail?.policeStation || "NA"}
                      </span>
                    </div>
                    </div>
                   </>}

                                      {/* <div className="flex justify-between gap10"style={{justifyContent:"end", marginTop:"10px"}}> <button onClick={()=>handleClick("/rent-aggrement-format")}  style={{fontSize:"14px",textDecoration:"underline",alignSelf:"flex-start"}}>Rent Aggrement Form</button> <button onClick={()=>handleClick("/police-verification-form")} style={{fontSize:"14px",textDecoration:"underline",alignSelf:"flex-start"}}>Verification form</button></div> */}
              
              
               
            </DropDownBox>
            }
            
            {isEmpty(user?.docList) ? null : (
              <>
                <DropDownBox>
                  <h2>Documents</h2>
                  <div className="row" style={{flexWrap:"wrap"}}>
                    {user?.docList &&
                      (user?.docList || []).map((item, index) => {
                        const status =
                          item?.status === "INACTIVE"
                            ? "reject"
                            : item?.status === "ACTIVE"
                            ? "approve"
                            : "pending";
                          const isPdf = item?.docLink?.split(".")?.at(-1)?.toLowerCase() === "pdf";
                          console.log("isPdfisPdfisPdf",isPdf)
                        return (
                          <div className="column document" style={{cursor:"pointer"}} key={index} onClick={() => setOpenDoc(item)}>
                            <h4 className="title"  >{item?.docName}</h4>
                            {
                              isPdf?<embed src={item?.docLink} type="application/pdf"  style={{ height: "60px", cursor: "pointer" }} onClick={() => setOpenDoc(item)}></embed>
                              :
                               <img
                              src={item?.docLink}
                              alt=""
                              style={{ height: "60px", cursor: "pointer" }}
                              // onClick={() => setOpenDoc(item)}
                            />
                            }
                           
                            <span class={`badge ${status}`} 
                            //  onClick={() => setOpenDoc(item)}
                             >{status}</span>
                          </div>
                        );
                      })}
                  </div>
                </DropDownBox>
               
              </>
            )}
             {showUpload && (
                  <DropDownBox>
                  <div className="flex justify-between">  <h2>Police Verification</h2> </div>
                    <div className="row">
                      <div className="column document">
                       

                        <FileUploadBox
                          onUploadFile={setFile}
                          fileUpload={file}
                          style={{ maxWidth: "700px" }}
                          show="true"
                           accept="image/jpeg,image/png,image/jpg,application/pdf"
                              title="Drag & Drop your police verification file here or click to select police verification file"
                        />
                        {!!file && (
                          <div className="buttons" style={{ alignSelf: "end" }}>
                            {" "}
                            <button
                              style={{ paddingInline: "20px" }}
                              disabled={loaderApprove}
                              onClick={uploadFile}
                            >
                              Upload
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </DropDownBox>
                )}
                { showUpload && (
                  <DropDownBox>
                  <div className="flex justify-between">  <h2>Rent Aggrement</h2> </div>
                    <div className="row">
                      <div className="column document">
                       

                        <FileUploadBox
                          onUploadFile={setFile1}
                          fileUpload={file1}
                          style={{ maxWidth: "700px" }}
                          show="true"
                           accept="image/jpeg,image/png,image/jpg,application/pdf"
                              title="Drag & Drop your rent-aggrement here or click to select rent-aggrement"
                        />
                        {!!file1 && (
                          <div className="buttons" style={{ alignSelf: "end" }}>
                            {" "}
                            <button
                              style={{ paddingInline: "20px" }}
                              disabled={loaderApprove}
                              onClick={()=>uploadFile("rent")}
                            >
                              Upload
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </DropDownBox>
                )}
          </>

        )}
      </SidebarPopup>
      {!isEmpty(openDoc) && (
        <ShowDoc
          doc={openDoc}
          close={() => setOpenDoc({})}
          user={user}
          setMessage={setMessage}
          refetch={() => handleApiData(mobile)}
        />
      )}
    </div>
  );
}

export default TenantKycDetails;

const ShowDoc = ({
  doc = {},
  close = () => {},
  user = {},
  setMessage = () => {},
  refetch = () => {},
}) => {
  const [zoom, setZoom] = useState(false);
  const [confirm, setConfirm] = useState(null);
  const [loader, setLoader] = useState(false);

  const defaultOptions1 = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
  };

  const toggleZoom = () => {
    setZoom(!zoom);
  };

  const approve = (type) => {
    setLoader(true);
    setConfirm(null);

    approverTenant(user?.uuid, doc?.docId, type)
      .then((res) => {
        console.log("4e1afc6eea15491c9ded",res?.data)
        if (res?.data?.message === "SUCCESS") {
          setMessage({
            type: "success",
            msg: `Document ${
              type === "ACTIVE" ? "approved" : "rejected"
            } successfully`,
          });
          refetch();
          setConfirm(null);
          close();
        } else {
          const errorMsg = res?.data?.errorCodeList?.length
            ? res?.data?.errorCodeList.join(", ")
            : res?.data?.msg;
          setMessage({
            type: "error",
            msg: errorMsg || "Error approving document",
          });
        }
      })
      .catch((err) => {
        setMessage({
          type: "error",
          msg: `Error approving document: ${
            err?.response?.data?.message || err.message
          }`,
        });
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const confirmHandler = () => {
    approve(confirm?.type);
  };

const ext =  doc?.docLink.split(".").at(-1);
console.log("ext",ext)

const isPdf =  ext?.toLowerCase() === "pdf";

  return (
    <>
      <ModalPopUp>
        {!isEmpty(confirm) && (
          <ModalData
            onClickCancel={() => setConfirm(null)}
            onClickConfirm={confirmHandler}
            lottieOptions={defaultOptions1}
            heading1={confirm?.msg}
            style={{ zIndex: "10000" }}
          />
        )}

        <div className="modal-popup"  style={isPdf?{width:"900px",height:"calc(100vh - 80px)"}:{}}>
          <div
            className="flex justify-center mr-20"
            style={{ color: "#8B9CA8" }}
            onClick={close}
          >
            <h2>{doc?.docName}</h2>
            <i
              className="fa-solid fa-xmark"
              style={{
                display: "inline-block",
                maxWidth: "40px",
                marginLeft: " auto",
                fontSize: "25px",
              }}
            ></i>
          </div>
          {
           isPdf?
            <div className="PdfViewer" style={{height:"calc(100% - 120px)"}}>
          <embed
  src={doc?.docLink}
  type="application/pdf"
  width="100%"
  height="100%"
  style={{display:"block"}}
/>
            {/* <iframe src={doc?.docLink} frameborder="0"></iframe> */}
            </div>
            :
             <PreviewImg>
            <div className="zoom-container">
              <img
                src={doc?.docLink}
                alt={doc?.docName}
                className={zoom ? "zoomed" : ""}
                onClick={toggleZoom}
              />
              {doc?.docLinkB && (
                <img
                  src={doc?.docLinkB}
                  alt={doc?.docNameB}
                  className={zoom ? "zoomed" : ""}
                  onClick={toggleZoom}
                />
              )}
            </div>
          </PreviewImg>
          }
         

          {doc?.status === "PENDING" && (
            <div className="flex justify-center gap-10 mt-30">
              <button
                onClick={() =>
                  setConfirm({
                    type: "INACTIVE",
                    msg: "Are you sure you want to reject this document?",
                  })
                }
                className="cancel_button"
                disabled={loader}
              >
                Reject
              </button>
              <button
                onClick={() =>
                  setConfirm({
                    type: "ACTIVE",
                    msg: "Are you sure you want to approve this document?",
                  })
                }
                className="confirm_button"
                disabled={loader}
              >
                Approve
              </button>
            </div>
          )}
        </div>
      </ModalPopUp>
    </>
  );
};

const PreviewImg = styled.div`
  .zoom-container {
    min-width: 400px;
    max-width: 500px;
    height: 400px;
    overflow: scroll;
    border-radius: 8px;
    border: 1px solid #ccc;
    cursor: zoom-in;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari */
    }
    img {
      width: 100%;
      transition: width 0.3s ease-in-out;
      &.zoomed {
        width: 200%;
        cursor: zoom-out;
      }
    }
  }
`;
